import styled from "styled-components"
import { fieldStyles } from "../styles"

export const StyledCurrencyWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #ccc;
`

export const StyledCurrencySymbol = styled.span`
  font-size: 1rem;
  color: #333;
  margin-left: 1rem;
  user-select: none;
`

export const StyledCurrencyInput = styled.input`
  ${fieldStyles}
  flex: 1;
  min-width: 0;
  padding: 12px 16px 12px 8px;
`
